import { useState, useEffect } from "react";
import { Cookie } from "lucide-react";
import { COOKIE } from "@/constants/testIds";

const KEY = "ps_cookie_consent";

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setShow(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    window.dispatchEvent(new CustomEvent("ps-cookie-decided", { detail: value }));
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid={COOKIE.banner}
      className="fixed z-[60] bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md"
    >
      <div className="bg-white rounded-2xl shadow-[0_20px_50px_rgb(0,0,0,0.18)] border border-[#5982c5]/15 p-5">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-[#ecfef7] flex items-center justify-center shrink-0">
            <Cookie size={20} className="text-[#5982c5]" />
          </div>
          <div>
            <p className="font-heading font-bold text-[#1f2937]">Rispettiamo la tua privacy</p>
            <p className="mt-1 text-sm text-[#4b5563] leading-relaxed">
              Usiamo i cookie per migliorare la tua esperienza e analizzare il traffico. Puoi accettarli
              o continuare solo con quelli essenziali.
            </p>
          </div>
        </div>
        <div className="mt-4 flex gap-2.5">
          <button
            data-testid={COOKIE.reject}
            onClick={() => decide("essential")}
            className="flex-1 border border-[#d1d5db] text-[#4b5563] hover:bg-[#f9fafb] font-semibold text-sm px-4 py-2.5 rounded-full transition-colors"
          >
            Solo essenziali
          </button>
          <button
            data-testid={COOKIE.accept}
            onClick={() => decide("all")}
            className="flex-1 bg-[#5982c5] text-white hover:bg-[#4a6fa8] font-semibold text-sm px-4 py-2.5 rounded-full transition-colors"
          >
            Accetta tutti
          </button>
        </div>
      </div>
    </div>
  );
}
